import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ChatMessageClient from '@core/src/nedoShared/features/chat/components/ChatComponent/ui/ChatMessage/ChatMessageClient/ChatMessageClient';
// import ChatMessageClient from './ChatMessageClient/ChatMessageClient'
// import ChatMessageDoctor from './ChatMessageDoctor/ChatMessageDoctor'
import ChatMessageProvider from './ChatMessageProvider/ChatMessageProvider';
export const ChatMessageComponent = (props) => {
    switch (props.role) {
        case 'client': {
            return _jsx(ChatMessageClient, Object.assign({}, props));
        }
        // case 'doctor': {
        //   return <ChatMessageDoctor {...props} />
        // }
        case 'provider': {
            return _jsx(ChatMessageProvider, Object.assign({}, props));
        }
        default: {
            // const _exhaustiveCheck: never = props.role
            // throw new Error(`Unhandled chat role: ${_exhaustiveCheck}`)
        }
    }
};
